import { Fragment, useState } from "react";
import { MapPin, Clock, Navigation } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./Reveal";
import { ADDRESS, HOURS, CENTER } from "./data";

const q = encodeURIComponent(`${ADDRESS.street}, ${ADDRESS.cap} ${ADDRESS.city} ${ADDRESS.prov}`);
export const MAPS_DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${q}`;

const MapBox = () => {
  const [on, setOn] = useState(false);
  return (
    <div className="relative h-full min-h-[380px] rounded-[2rem] overflow-hidden bg-[#DCE5D8] border border-[#1B3B28]/10" data-testid="location-map">
      {on ? (
        <iframe title={`Mappa ${CENTER}`} src={`https://www.google.com/maps?q=${q}&output=embed`} className="absolute inset-0 w-full h-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="location-map-iframe" />
      ) : (
        <div className="absolute inset-0 grid place-items-center p-8 text-center bg-[radial-gradient(circle_at_50%_40%,rgba(134,200,155,0.45),transparent_60%)]">
          <div>
            <span className="relative inline-grid place-items-center w-16 h-16 rounded-full bg-[#1B3B28] text-[#FCFBF7]"><span className="pulse-ring absolute inset-0 rounded-full bg-[#86C89B]" /><MapPin size={24} className="relative" /></span>
            <p className="f-serif text-3xl text-[#1B3B28] mt-6">{ADDRESS.street}</p>
            <p className="text-[#526356]">{ADDRESS.cap} {ADDRESS.city} ({ADDRESS.prov})</p>
            <button onClick={() => setOn(true)} className="mt-6 rounded-full bg-[#FCFBF7] border border-[#1B3B28]/15 px-5 py-2.5 text-sm text-[#1B3B28] hover:bg-[#E6ECE4] transition-colors" data-testid="location-load-map-btn">Mostra la mappa</button>
            <p className="text-xs text-[#526356] mt-3 max-w-xs mx-auto">La mappa è fornita da Google Maps e viene caricata solo se la apri.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export const Location = () => (
  <section id="dove" className="relative py-28 sm:py-36 bg-[#F4F3EC]" data-testid="location-section">
    <div className="mx-auto max-w-[1400px] px-6 sm:px-10 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-5">
        <SectionHead eyebrow="Dove siamo" lines={["Ti aspettiamo", "a Galliera."]} intro={`Il Dott. Nicola Mauro segue i percorsi parodontali presso il ${CENTER}.`} />
        <Reveal delay={0.1}>
          <div className="mt-10 space-y-6">
            <div className="flex gap-4" data-testid="location-address">
              <span className="w-11 h-11 shrink-0 grid place-items-center rounded-full bg-[#E6ECE4] text-[#1B3B28]"><MapPin size={18} /></span>
              <p className="text-[#1B3B28]"><b className="font-medium">{CENTER}</b><br />{ADDRESS.street}<br />{ADDRESS.cap} {ADDRESS.city} ({ADDRESS.prov})</p>
            </div>
            <div className="flex gap-4" data-testid="location-hours">
              <span className="w-11 h-11 shrink-0 grid place-items-center rounded-full bg-[#E6ECE4] text-[#1B3B28]"><Clock size={18} /></span>
              <dl className="grid grid-cols-[auto_1fr] gap-x-8 gap-y-1.5 text-sm">
                {HOURS.map(([d, h]) => (<Fragment key={d}><dt className="text-[#526356]">{d}</dt><dd className={h === "Chiuso" ? "text-[#526356]" : "text-[#1B3B28] font-medium"}>{h}</dd></Fragment>))}
              </dl>
            </div>
            <a href={MAPS_DIRECTIONS} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#1B3B28] text-[#FCFBF7] px-6 py-3.5 text-sm hover:bg-[#3E6B48] transition-colors" data-testid="location-directions-btn">
              <Navigation size={15} /> Indicazioni stradali
            </a>
          </div>
        </Reveal>
      </div>
      <Reveal className="lg:col-span-7" delay={0.2}><MapBox /></Reveal>
    </div>
  </section>
);
